export const PrivacyPolicy = () => {
  return <div>Privacy</div>;
};
